<template>
  <div class="tab-toggle">
    <div
      class="item"
      :class="[activeId == item.id ? 'active' : '']"
      :key="item.value"
      v-for="item in list"
      @click="toggle(item.id, item)"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
import { ref, toRefs } from "vue"
export default {
  name: "TabToggle",
  props: {
    defaultId: {
      type: [Number, String],
      default: 1,
    },
    list: {
      type: Array,
      default() {
        return [
          {
            name: "待处理",
            id: "1",
          },
          {
            name: "已处理",
            id: "2",
          },
        ]
      },
    },
  },
  setup(props, { emit }) {
    let { defaultId } = toRefs(props)
    const activeId = ref(defaultId.value)
    const toggle = (id, item) => {
      activeId.value = id
      emit("onChange", item)
    }

    return {
      activeId,
      toggle,
    }
  },
}
</script>

<style lang="less" scoped>
.tab-toggle {
  display: flex;
  height: 44px;
  padding: 0 15px;
  background-color: #fff;
  .item {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    &.active{
      color: #4275fd;
      font-weight: 600;
    }
    &.active::after {
      background-color: #4275fd;
    }
    &::after {
      position: absolute;
      display: inline-block;
      content: " ";
      width: 15px;
      height: 3px;
      bottom: 3px;
      left: calc(50% - 8px);
      border-radius: 3px;
      background-color: transparent;
    }
  }
}
</style>
